import React, { useState } from 'react';
import { richTextValidation } from 'validators';
import { Controller, useFormContext } from 'react-hook-form';
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { TextField, TextButton } from 'seagull';
export default function BillingItemNote(props) {
  const {
    control
  } = useFormContext();
  const {
    testid
  } = props;
  const {
    BILL_CLIENT
  } = useFeatureFlags();
  const [isAddingNote, setIsAddingNote] = useState(!BILL_CLIENT);
  return isAddingNote ? /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: props.name,
    rules: richTextValidation('Note'),
    render: _ref => {
      let {
        field: {
          value,
          ref,
          onChange,
          onBlur
        },
        fieldState: {
          isTouched,
          error
        }
      } = _ref;
      return /*#__PURE__*/React.createElement(TextField, {
        multiline: true,
        width: 500,
        label: "Notes (optional)",
        minRows: 3,
        maxRows: 3,
        testid: testid,
        error: isTouched && !!error,
        helperText: isTouched && error && error.message,
        value: value,
        inputRef: ref,
        onChange: onChange,
        onBlur: onBlur
      });
    }
  }) : /*#__PURE__*/React.createElement(TextButton, {
    underline: "none",
    "data-testid": testid && "".concat(testid, "-add-note"),
    onClick: () => setIsAddingNote(true)
  }, "+ Add Note");
}